/*
 *	@param {string} type ["category" | "family" | "designer" | "all"]
 */
function resetFilter(type) {
	document.querySelector(".no-results-message").classList.add("hidden");

	if (type == "all") {
		resetFilter("category");
		resetFilter("family");
		resetFilter("designer");

		let ctx = document.querySelector(".archive");

		if (ctx != null) {
			ctx.classList.add("--loading");
			ctx.querySelectorAll(".hidden").forEach((i) => {
				i.classList.remove("hidden");
				i.removeAttribute("data-defer");
			});

			let noResultsMessage = document.querySelector(".no-results-message");

			if (noResultsMessage != null) noResultsMessage.classList.add("hidden");

			ctx.classList.remove("--loading");
		}
	} else {
		if (document.getElementById("filter-" + type) != null) document.getElementById("filter-" + type).classList.remove("--filtered");

		if (document.querySelectorAll("#filter-" + type + " li.--active").length > 0)
			document.querySelectorAll("#filter-" + type + " li.--active").forEach((i) => {
				i.classList.remove("--active");
			});
	}

	setTimeout(() => {
		ScrollTrigger.refresh();
	}, 500);

	window.scrollTo({ top: 0, behavior: "smooth" });
}

function refreshBanners() {
	let banner = document.querySelector(".banner .archive-item");
	let freq = banner != null ? banner.dataset.frequency : -1;
	let ctx = document.querySelector(".archive");

	if (ctx != null) {
		ctx.querySelectorAll("[data-banner]").forEach((i) => {
			i.remove();
		});

		let items = Array.from(document.querySelectorAll(".archive-item:not(.hidden)"));
		let bannerCount = 0;

		if (banner != null) {
			for (var i = 0; i < items.length; i++) {
				if ((i + 1) % freq == 0) {
					items[i].after(banner.cloneNode(true));
					bannerCount++;
				}
			}

			if (bannerCount == 0) {
				ctx.appendChild(banner.cloneNode(true));
			}
		}
	}
}

function bindFiltersControls() {
	/*
	 * Filter/sorting
	 */
	document.querySelectorAll(".filters-panel:not(.ra-filters) .filter-group").forEach((group) => {
		group.addEventListener("click", (evt) => {
			let filterItem = evt.target.closest("a");

			if (!filterItem) return;

			if (!("prop" in filterItem.dataset)) return;

			let filterType = filterItem.dataset.prop;
			let items = Array.from(document.querySelectorAll(".archive-item:not([data-banner]"));

			if (filterType == "alpha" || filterType == "date") {
				resetFilter("sort");

				// Sorts products
				let sortedItems;

				switch (filterType) {
					case "alpha":
						sortedItems = items.sort((a, b) => {
							return a.dataset.alpha.localeCompare(b.dataset.alpha);
						});
						break;

					case "date":
						sortedItems = items.sort((a, b) => {
							return b.dataset.date - a.dataset.date;
						});
						break;
				}

				let ctx = document.querySelector(".archive");

				ctx.classList.add("--loading");
				ctx.innerHTML = "";

				sortedItems.forEach((i) => {
					ctx.appendChild(i);
				});

				refreshBanners();
				ctx.classList.remove("--loading");

				/* DELAYED VERSION
				sleep(500).then(() => {
					ctx.innerHTML = "";

					sorted.forEach((i) => {
						ctx.appendChild(i);
					});
				});
				
				sleep(500).then(() => { ctx.classList.remove('--loading'); });
				*/

				initDeferAnimation();
			} else {
				if (!("val" in filterItem.dataset)) return;

				let filterValue = filterItem.dataset.val;
				let ctx = document.querySelector(".archive");
				let noResultsMessage = document.querySelector(".no-results-message");
				let hiddenCount = 0;

				// Filters products
				resetFilter("all");
				ctx.classList.add("--loading");

				if (noResultsMessage != null) {
					noResultsMessage.classList.add("hidden");
				}

				items.forEach((item) => {
					// if (item.dataset[filterType].indexOf(filterValue) < 0) {
					// 	item.classList.add("hidden");
					// 	item.removeAttribute("data-defer");
					// 	hiddenCount++;
					// }

					const isHidden = filterType === "family"
						? item.dataset[filterType] != filterValue
						: item.dataset[filterType].indexOf(filterValue) < 0;

					if (isHidden) {
						item.classList.add("hidden");
						item.removeAttribute("data-defer");
						hiddenCount++;
					}
				});

				// no results
				if (hiddenCount == items.length) {
					if (noResultsMessage != null) {
						noResultsMessage.classList.remove("hidden");
					}
				}

				refreshBanners();
				// Fa il refresh di tutti gli scrollTrigger per footer
				setTimeout(() => {
					ScrollTrigger.refresh();
				}, 500);

				initDeferAnimation();
				ctx.classList.remove("--loading");
			}

			// Updates selected filter option
			filterItem.closest("li").classList.add("--active");
			filterItem.closest("ul").classList.add("--filtered");
			// Closes filters panel
			document.querySelector(".filters-panel").classList.toggle("--open");
		});
	});
}

document.addEventListener("DOMContentLoaded", function (evt) {
	if (document.querySelectorAll(".filters").length > 0) {
		// Moves filters panel at the end of the body for better layout
		document.body.appendChild(document.querySelector(".filters-panel"));

		document.querySelectorAll(".filters-toggle").forEach((elem) => {
			elem.addEventListener("click", (_evt) => {
				if (!document.querySelector(".filters-panel")) return;

				document.querySelector(".filters-panel").classList.toggle("--open");
				document.body.classList.add("--filters-open");
				_evt.stopPropagation();
			});
		});

		document.querySelectorAll(".filters-reset").forEach((elem) => {
			elem.addEventListener("click", (_evt) => {
				if (!document.querySelector(".filters-panel")) return;

				resetFilter("all");
				_evt.stopPropagation();

				if (document.querySelectorAll(".archive .archive-item").length > 0) {
					document.querySelector(".no-results-message").classList.add("hidden");
				} else {
					document.querySelector(".no-results-message").classList.remove("hidden");
				}
			});
		});

		bindFiltersControls();

		// Closing filters panel when clicking outside
		document.body.addEventListener("click", (e) => {
			if (document.body.classList.contains("--filters-open")) {
				document.querySelector(".filters-panel").classList.remove("--open");
				document.querySelector(".filters-panel").classList.remove("--filters-open");
			}
		});

		/*
		 * View switch
		 */
		const archiveItems = document.querySelectorAll(".archive-item:not([data-banner])");
		// const mobileMediaQuery        = window.matchMedia("(max-width: 776px)");
		// const largeDesktopsMediaQuery = window.matchMedia("(min-width: 1200px)");

		document.querySelectorAll(".view-toggle").forEach((elem) => {
			// if (mobileMediaQuery.matches) {
			// 	elem.classList.add('single');
			// 	elem.classList.remove('multiple');
			// } else if (largeDesktopsMediaQuery.matches) {
			// 	elem.classList.add('single');
			// 	elem.classList.remove('multiple');
			// }

			const singleView = elem.dataset.singleView;
			const multipleView = elem.dataset.multipleView;

			elem.addEventListener("click", (_evt) => {
				elem.classList.toggle("single");
				elem.classList.toggle("multiple");

				let archiveItems = document.querySelectorAll(".archive-item:not([data-banner])");

				archiveItems.forEach((item) => {
					if (singleView && multipleView) {
						singleView.split(" ").forEach((c) => item.classList.toggle(c));
						multipleView.split(" ").forEach((c) => item.classList.toggle(c));
					} else {
						item.classList.toggle("col-1");
						item.classList.toggle("col-2");
						item.classList.toggle("xl:col-6");
					}

					// if (mobileMediaQuery.matches) {
					// 	item.classList.toggle('col-1');
					// 	item.classList.toggle('col-2');
					// } else if (largeDesktopsMediaQuery.matches) {
					// 	item.classList.toggle('xl:col-6');
					// }
				});

				setTimeout(() => {
					ScrollTrigger.refresh();
				}, 500);
				// _evt.stopPropagation();
			});
		});
	}
});
